import { finish, error } from '../../../modules/user/actions/get-transactions';

import api from '../../../api';

export function request(dispatch, { transactionType: type, startDate, endDate, page, sort }) {
    if (startDate) {
        startDate += 'T00:00:00';
    }

    if (endDate) {
        endDate += 'T23:59:59';
    }

    api.get('/user/transactions', {
        sort: sort || '-date',
        startDate,
        endDate,
        page,
        type
    }, {
        cache: true
    }).then(
        ({ data }) => dispatch(finish(data)),
        ({ errors }) => dispatch(error(errors))
    );
}
